import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import WebApp from '@twa-dev/sdk';

import { useApp } from '../contexts/AppContext';
import { notificationEmit } from '../controllers/NotificationsController';
import { friendsLevels, getLevel, getTgUserId } from '../../src/lib/utils';
import { env } from '../../src/lib/env';
import {
  InviteFriendsForm,
  InviteFriendsNote,
  MysteryChest,
  PageContainer,
  FriendsNote,
  MysteryChestSubscribe,
} from '../components/Wrappers';

const Friends = () => {
  const { user } = useApp();
  const [subscriptionState, setSubscriptionState] = useState('init');
  const [totals, setTotals] = useState({
    level: 0,
    total: 0,
    friendsCount: 0,
    friendsCountNext: 0,
    percentage: 0,
  });

  const urlInvitation = `${env.botUrl}?startapp=${getTgUserId()}`;

  const handleCopy = () => {
    notificationEmit({
      title: 'Invite friends!',
      subtitle: 'The invitation link has been copied to your clipboard!',
    });

    document.getElementById('invitationLink')?.classList.add('copied');
  };

  useEffect(() => {
    const index = getLevel(user);
    const friendsCount = friendsLevels[index][1];
    const friendsCountNext = friendsLevels[index + 1][1];
    const total = user.friendsLevel1Count + user.friendsLevel2Count;

    setTotals({
      level: friendsLevels[index][0],
      total,
      friendsCount,
      friendsCountNext,
      percentage: (total / friendsCountNext) * 100,
    });
  }, []);

  console.log('user', user.isSubscribed, totals);

  const handleSubscribe = () => {
    WebApp.openTelegramLink(`https://t.me/${env.channelName}`);
    setSubscriptionState('loading');

    notificationEmit({
      title: 'Join Our Community on Telegram!',
      subtitle: 'Open Telegram and subscribe to our channel for the latest updates and exclusive content!',
    });

    setTimeout(() => {
      setSubscriptionState('ready');
    }, 5000);
  };

  const handleSubscribeCheck = () => {
    localStorage.setItem('telegramSubscribed', 'OFF');
    setSubscriptionState('checking');
    notificationEmit({
      title: 'Welcome to the Community!',
      subtitle: 'Thank you for subscribing to our channel! Stay tuned for the latest updates and exclusive content.',
    });

    setTimeout(() => {
      location.reload();
    }, 5000);
  };

  const handleFriendsInvite = () => {
    notificationEmit({
      title: 'Invite a Friend for Rewards!',
      subtitle: 'Earn exclusive rewards by inviting a friend to join the fun!',
    });

    WebApp.openTelegramLink(
      `https://t.me/share/url?url=${encodeURIComponent(`${env.botUrl}?startapp=${getTgUserId()}`)}`
    );
  };

  return (
    <div>
      <PageContainer>
        {!user.isSubscribed ? (
          <>
            <InviteFriendsNote>
              <nav>
                <h3>Invite Friends</h3>
                <NavLink to="/friends/note">
                  <img src="/img/IconInformation.svg" />
                </NavLink>
              </nav>
              <p>Complete tasks and get benefits before the game starts</p>
            </InviteFriendsNote>
            <MysteryChestSubscribe>
              <img className="box" src="/img/MysteryChest.png" alt="Worried Meerkats" title="Worried Meerkats Logo" />
              <h3>Treasure Box</h3>
              <p>This box contains a meerkat, a well-known figure in the crypto industry</p>
              <div className="subscription">
                <p style={{ color: '#d57bff' }}>To receive a Treasure Box</p>
                <p>Subscribe to the Worried Meerkats telegram channel</p>
                <img src="/img/IconTelegram.png" alt="Worried Meerkats" title="Worried Meerkats Telegram" />
                <nav>
                  {subscriptionState === 'init' && (
                    <>
                      <button className="open" onClick={handleSubscribe}>
                        Subscribe
                      </button>
                    </>
                  )}
                  {subscriptionState === 'loading' && (
                    <>
                      <button className="open" onClick={handleSubscribe}>
                        Loading ...
                      </button>
                    </>
                  )}
                  {subscriptionState === 'ready' && (
                    <>
                      <button className="check" onClick={handleSubscribeCheck}>
                        Check Subscription
                      </button>
                    </>
                  )}
                  {subscriptionState === 'checking' && (
                    <>
                      <button className="check">Checking ...</button>
                    </>
                  )}
                </nav>
              </div>
              <p>This chest contains a meerkat, a well-known figure in the crypto industry</p>
            </MysteryChestSubscribe>
          </>
        ) : (
          <>
            <InviteFriendsNote>
              <nav>
                <h3>Invite Friends</h3>
                <NavLink to="/friends/note">
                  <img src="/img/IconInformation.svg" />
                </NavLink>
              </nav>
              <p>
                The more friends you and your friends invite to the game, the higher the level of your chest will be
              </p>
            </InviteFriendsNote>
            <MysteryChest>
              <div>
                <h3>Treasure Box</h3>
                <>
                  {totals.total > 0 ? (
                    <>
                      <p className="level">Level {totals.level}</p>
                      <p className="levelUp">
                        <img src="/img/IconFriend.svg" />
                        {totals.total}/{totals.friendsCountNext}
                        <NavLink to="/friends/note">
                          <img src="/img/IconInformation.svg" />
                        </NavLink>
                      </p>
                    </>
                  ) : (
                    <>
                      <p className="level">Level 1</p>
                      <p className="levelOne">To get a Level 1 Treasure Box</p>
                      <p className="levelLink">Invite your first friend to the game</p>
                    </>
                  )}
                </>
              </div>
              {totals.total > 0 ? (
                <>
                  <img src="/img/MysteryChest.png" alt="Worried Meerkats" title="Worried Meerkats Logo" />
                  <div className="progress">
                    <span style={{ width: `${totals.percentage}%` }} />
                  </div>
                </>
              ) : (
                <img src="/img/MysteryChestBW.png" alt="Worried Meerkats" title="Worried Meerkats Logo" />
              )}
            </MysteryChest>
            <InviteFriendsForm>
              <nav>
                <div>
                  <span>
                    <img src="/img/IconFriend.svg" /> {user.friendsLevel1Count}
                  </span>
                  Friends
                  <br />1 level
                </div>
                <div>
                  <span>
                    <img src="/img/IconFriend.svg" /> {user.friendsLevel2Count}
                  </span>
                  Friends
                  <br />2 level
                </div>
                <button onClick={handleFriendsInvite}>
                  Invite
                  <br />
                  Friends
                </button>
              </nav>
              <div id="invitationLink">
                <input value={urlInvitation} className="link" disabled />
                <input value="Your link has been copied!" className="message" disabled />
                <CopyToClipboard text={urlInvitation} onCopy={() => handleCopy()}>
                  <button>
                    <img src="/img/IconCopy.svg" />
                  </button>
                </CopyToClipboard>
              </div>
            </InviteFriendsForm>
            <FriendsNote>
              <h3>All your friends will stay with you forever</h3>
              <p>and will bring you additional income throughout the next game</p>
              <div className="note">
                <p>
                  Your <span>Treasure Box</span> is now available and ready to be opened. Dive in to discover the
                  exciting rewards that await you! Each item inside brings you one step closer to even greater
                  treasures.
                </p>
                <img src="/img/MysteryChest.png" alt="Worried Meerkats" title="Worried Meerkats Logo" />
              </div>
            </FriendsNote>
          </>
        )}
      </PageContainer>
    </div>
  );
};

export default Friends;
